import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router"
import { useToitEnPente } from "../../../store/toit-en-pente/hooks"
import { useRoutes } from "../../../store/routes/hooks"
import {
  ToitEnPenteClimateTypes,
  ToitEnPenteInsulationTypes,
} from "@iko-design-center/shared"
import { renderer } from "../../viewer/Renderer"

export function useToitStructure() {
  const { Routes } = useRoutes() as any
  const { t } = useTranslation() as any
  const history = useHistory()

  const {
    configurationState,
    setToitInsulationType: setToitInsulationTypeState,
    setToitClimateType: setToitClimateTypeState,
    setToitStructureType: setToitStructureTypeState,
  } = useToitEnPente()

  const toitClimateType = configurationState.toitClimate.type
  const toitStructureType = configurationState.toitStructure.type
  const nextButtonDisabled = !toitStructureType

  useEffect(() => {
    setToitClimateTypeState(ToitEnPenteClimateTypes.PLAIN_CLIMATE)
    setToitInsulationTypeState(ToitEnPenteInsulationTypes.ALU_NF_AS)
  }, [setToitInsulationTypeState, setToitClimateTypeState])

  function handleNextButtonClick() {
    history.push(Routes.TOIT_EN_PENTE_2_RAIN_COVER)
  }

  function setToitStuctureType(type: any) {
    setToitStructureTypeState(type)
    renderer.displayToitEnPenteStructureType(type)
  }

  return {
    t,
    toitClimateType,
    toitStructureType,
    setToitStuctureType,
    handleNextButtonClick,
    nextButtonDisabled,
  }
}
